import React from 'react';

import JoinIcon from '../../icons/JoinIcon';

const colors = require('common/lib/colors/colors.less');
import IconButton from './IconButton';

const JoinButton = (props) => (
  <IconButton {...props} icon={<JoinIcon color={colors.N100} />}>
    Join
  </IconButton>
);

export default JoinButton;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/buttons/JoinButton.js